// extracted by mini-css-extract-plugin
export default {"Packages":"Yaw79rpy37L8occrOrcw","h2":"vQJmBTrJuP91hjuxAjd6","requestPackageTosSecondLine":"HUWLaK8ucGLj0UJNGSuw"};